import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { objectToArray, _t } from 'utils';
import moment from 'moment';
import Shared from 'screens/shared';
import EditForm from 'screens/alb/create-forwarding-rule';
import { ROUTE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';

export default ({ history, match }) => {
  const { dcId, albId, id } = match.params;
  const {
    [ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.GET_FORWARDING_RULE]: rule = {},
    [ACTIONS_TYPES.CERTIFICATE_MANAGER.GET_ALL]: certificate = [],
  } = useSelector((e) => e);
  const { properties = {}, metadata = {} } = rule;

  useEffect(() => {
    actions.certificateManager.getAll();
    actions.applicationLoadbalancer.getForwardingRule({ dcId, forwardingRuleId: id, id: albId });
  }, [dcId, albId, id]);

  const propertiesRows = [
    ['Protocol', <span className="color-base">{properties?.protocol}</span>],
    ['Listener IP', <Shared.utilities.IPs ips={[properties?.listenerIp]} />],
    ['Listener Port', <span className="color-base">{properties?.listenerPort}</span>],
    ['Client Timeout', <span className="color-base">{properties?.clientTimeout}</span>],
    ['Created Date', moment(metadata?.createdDate).fromNow()],
    [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
  ];

  const deleteHandler = () => {
    actions.applicationLoadbalancer.deleteForwardingRule();
    history.goBack();
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.ALB_FORWARDING_RULE}
      strapTitle={properties?.name}
      strapIcon="angle-double-right"
      onDelete={deleteHandler}
      editForm={<EditForm item={{ id, ...properties }} />}
      editAction={ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.UPDATE_FORWARDING_RULE}
    >
      <Shared.widgets.Properties properties={propertiesRows} />

      <Shared.widgets.Section
        className="p-t-12"
        sectionTitle="Certificates"
        items={properties?.serverCertificates || []}
        itemIcon="shield-alt"
        setItemTitle={(e) => certificate.find(({ id: cid }) => cid === e)?.properties?.name}
      />

      <Shared.widgets.Section
        className="p-t-24"
        sectionTitle="HTTP Rules"
        items={properties?.httpRules || []}
        itemIcon="angle-double-right "
        setItemTitle={(e) => e?.name}
        setItemDetails={(e) => e?.type}
        isItemDetailsModel
        setDetailsModelTable={(e) => {
          const { conditions = [], ...rest } = e;
          const arrCond = conditions.map((x, i) => [`Condition ${i + 1}`, <Shared.widgets.Properties title="" properties={objectToArray(x)} />]);
          return [...objectToArray(rest), ...arrCond];
        }}
      />

    </Shared.widgets.Page>
  );
};
